import {LOCALE_ID, NgModule} from "@angular/core";
import {CommonModule, registerLocaleData} from "@angular/common";
import { CoreComponent } from './core.component';
import {MatButtonModule} from "@angular/material/button";
import {MatDividerModule} from "@angular/material/divider";
import {MatIconModule, MatIconRegistry} from "@angular/material/icon";
import {MAT_DATE_LOCALE, MatLineModule, MatNativeDateModule} from "@angular/material/core";
import {MatListModule} from "@angular/material/list";
import {MatSidenavModule} from "@angular/material/sidenav";
import {NotificationModule} from "./reusable-components/notification/notification.module";
import {RouterLinkActive, RouterLink, RouterOutlet} from "@angular/router";
import {MatBadgeModule} from "@angular/material/badge";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {TrunksModule} from "./trunks/trunks.module";
import {UsersModule} from "./users/users.module";
import {StoreModule} from "@ngrx/store";
import {reducers} from "./+state/root.reducer";
import {environment} from "environments/environment";
import {StoreRouterConnectingModule} from "@ngrx/router-store";
import {CustomRouteSerializer} from "./+state/custom-route.serializer";
import {EffectsModule} from "@ngrx/effects";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {HttpErrorInterceptor} from "./utility/interceptors/http-error.interceptor";
import {AuthInterceptor} from "./utility/interceptors/auth.interceptor";
import {getGermanPaginatorIntl} from "./utility/localization/german-paginator-intl";
import {PendingChangesGuard} from "./utility/guards/pending-changes.guard";
import localeDe from "@angular/common/locales/de";

@NgModule({ declarations: [CoreComponent],
    exports: [
        CoreComponent,
    ], imports: [CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatLineModule,
        MatListModule,
        MatSidenavModule,
        MatBadgeModule,
        NotificationModule,
        RouterLinkActive,
        RouterLink,
        RouterOutlet,
        BrowserAnimationsModule,
        TrunksModule,
        UsersModule,
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictActionImmutability: true,
                strictStateImmutability: true
            }
        }),
        StoreRouterConnectingModule.forRoot({
            serializer: CustomRouteSerializer
        }),
        EffectsModule.forRoot([]),
        [environment.production ? [] : StoreDevtoolsModule.instrument({ connectInZone: true })],
        MatNativeDateModule], providers: [
        PendingChangesGuard,
        { provide: LOCALE_ID, useValue: "de-DE" },
        { provide: MAT_DATE_LOCALE, useValue: "de-DE" },
        { provide: MatPaginatorIntl, useValue: getGermanPaginatorIntl() },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class CoreModule {
  constructor(iconRegistry: MatIconRegistry) {
    registerLocaleData(localeDe);
    iconRegistry.setDefaultFontSetClass('material-icons-sharp');
  }
}
